<script>
import RawData from "@/components/widgets/raw-data.vue";
import ProposalTabs from "@/components/widgets/proposal-tabs.vue";
export default {
    name: "ProposalList",
    components: {
        RawData,
        ProposalTabs,
    },
    props: {
        proposals: {
            type: Array,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        viewFrom: {
            type: String,
            default: "planning",
        },
        selectedTemplate: {
            type: Object,
            default: () => ({}),
        },
        budgets: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            filter: "",
        };
    },
    computed: {
        upperCaseType() {
            return this.type.charAt(0).toUpperCase() + this.type.slice(1);
        },
        filtered() {
            if (!this.filter || !this.filter.trim()) return this.proposals;
            const search = this.filter.toLowerCase().trim();
            return this.proposals
                .map(campus => {
                    const filteredDus = (campus.dus || []).filter(du =>
                        du.deliveryUnit && du.deliveryUnit.toLowerCase().includes(search)
                    );
                    return {
                        ...campus,
                        isOpen: filteredDus.length > 0 ? true : campus.isOpen,
                        dus: filteredDus
                    };
                })
                .filter(campus => campus.dus.length > 0);
        },
        totalProposals() {
            let total = 0;
            this.proposals.map(campus => {
                campus.dus.map(du => {
                    du.proposals.map(proposal => {
                        total += parseFloat(proposal.total)
                    })
                })
            })
            return this.formatCurrency(total);
        },
    },
    methods: {
        runningTotal(du, type) {
            let total = 0;
            if (type == 'du') {
                du.proposals.map(proposal => {
                    total += parseFloat(proposal.total)
                })
            } else {
                du.dus.map(du => {
                    du.proposals.map(proposal => {
                        total += parseFloat(proposal.total)
                    })
                })
            }
            return this.formatCurrency(total);
        }
    }
};
</script>
<template>
    <div class="card shadow-none">
        <div class="card-header py-2">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex flex-column">
                    <h5 class="mb-1">{{ upperCaseType }} Proposals</h5>
                    <input type="text" v-model="filter" placeholder="Search Delivery Unit..."
                        class="form-control form-control-sm w-300px" />
                </div>
                <p
                    class="text-right d-flex text-white font-weight-bold font-size-16 gap-1 line-height-1 mb-0  flex-column">
                    Overall {{ upperCaseType }} Running Total:
                    <span class="font-size-24 text-warning font-weight-bold">{{ totalProposals }}</span>
                </p>
            </div>
        </div>
        <div class="card-body pt-2">
            <template v-if="!proposals.length">
                <div class="d-flex justify-content-center align-items-center py-5">
                    <h5 class="text-muted mb-0">No {{ upperCaseType }} Proposals</h5>
                </div>
            </template>
            <template v-else>
                <div class="border rounded py-2 px-2 mb-1 position-relative" v-for="(campus, campIndex) in filtered"
                    :key="campus.id">
                    <RawData :data="campus" v-if="$store.state.decrypt.isAdmin()"
                        :keyId="`${type}-campus-${campus.id}`" />
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex gap-1">
                            <h4 class="mb-0 hover-underline cursor-pointer" :class="{ 'text-white': campus.isOpen }"
                                @click="campus.isOpen = !campus.isOpen">{{ campus.campus }}</h4>
                            <b-dropdown id="dropdown-dropleft" right variant="purple btn-xs"
                                toggle-class="text-decoration-none" menu-class="dropdown-menu" no-caret>
                                <template #button-content>
                                    <i class="bx bx-printer"></i>
                                    Reports
                                    <i class="bx bx-chevron-down me-1"></i>
                                </template>
                                <b-dropdown-item @click="$emit('print-form2', { campusId: campus.id })">
                                    <i class="bx bx-printer me-1"></i>
                                    Form 2 - RDC
                                </b-dropdown-item>
                                <b-dropdown-item @click="$emit('print-form5', { campusId: campus.id })">
                                    <i class="bx bx-printer me-1"></i>
                                    DBM Form 5 - Tier 1
                                </b-dropdown-item>
                                <b-dropdown-item @click="$emit('print-form7', { campusId: campus.id })">
                                    <i class="bx bx-printer me-1"></i>
                                    DBM Form 7 - Tier 2
                                </b-dropdown-item>
                                <b-dropdown-item @click="$emit('print-form8', { campusId: campus.id, duId: null })">
                                    <i class="bx bx-printer me-1"></i>
                                    Form 8 - Budget Summary
                                </b-dropdown-item>
                                <b-dropdown-item @click="$emit('print-dbm-form8', { campusId: campus.id })">
                                    <i class="bx bx-printer me-1"></i>
                                    DBM Form 8
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>

                        <div class="d-flex flex-column">
                            <p class="text-right d-flex gap-1 line-height-1 mb-2 flex-column">
                                Campus {{ upperCaseType }} Total:
                                <span class="font-size-14 text-warning font-weight-bold">{{ runningTotal(campus,
                                    'campus')
                                    }}</span>
                            </p>
                        </div>
                    </div>
                    <b-collapse :visible="campus.isOpen" :accordion="`${type}-campus-${campus.id}`" role="tabpanel">
                        <div class="border-top px-2 py-2 position-relative" v-for="(du, duIndex) in campus.dus"
                            :key="du.id">
                            <RawData :data="du" v-if="$store.state.decrypt.isAdmin()" :keyId="`${type}-du-${du.id}`" />
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex gap-1">
                                    <h5 class="mb-0 line-height-1 hover-underline cursor-pointer d-flex align-items-center gap-1"
                                        :class="{ 'text-warning': du.isOpen }" @click="du.isOpen = !du.isOpen">
                                        <i class="mdi mdi-circle font-size-12"></i>{{ du.deliveryUnit }}
                                    </h5>
                                    <b-dropdown id="dropdown-dropleft" right variant="purple btn-xs"
                                        toggle-class="text-decoration-none" menu-class="dropdown-menu">
                                        <template #button-content>
                                            <i class="bx bx-printer"></i> Print
                                        </template>
                                        <b-dropdown-item
                                            @click="$emit('print-form8', { campusId: null, duId: du.id, summary: false })">
                                            Budget Details</b-dropdown-item>
                                        <b-dropdown-item
                                            @click="$emit('print-form8', { campusId: null, duId: du.id, summary: true })">
                                            Budget Summary</b-dropdown-item>
                                        <b-dropdown-item
                                            @click="$emit('print-form8', { campusId: null, duId: du.id, summary: true, detailed: true })">
                                            Budget Detailed Summary</b-dropdown-item>
                                    </b-dropdown>
                                </div>
                                <div class="d-flex flex-column">
                                    <p class="text-right d-flex gap-1 line-height-1 mb-0 flex-column">
                                        DU {{ upperCaseType }} Total:
                                        <span class="font-size-14 text-warning font-weight-bold">{{ runningTotal(du,
                                            'du')
                                        }}</span>
                                    </p>
                                </div>
                            </div>
                            <b-collapse :visible="du.isOpen" :accordion="`${type}-du-${du.id}`" role="tabpanel">
                                <ProposalTabs :du="du" :campus="campus" :type="type" :viewFrom="viewFrom"
                                    :filter="filter" :campIndex="campIndex" :duIndex="duIndex"
                                    :totalCampuses="filtered.length" :selectedTemplate="selectedTemplate"
                                    :budgets="budgets" @view-resources="$emit('view-resources', $event)"
                                    @show-api-attachments="$emit('show-api-attachments', $event)"
                                    @show-api-logs="$emit('show-api-logs', $event)"
                                    @view-proposal-data="$emit('view-proposal-data', $event)"
                                    @approve-proposal="$emit('approve-proposal', $event)"
                                    @return-proposal="$emit('return-proposal', $event)"
                                    @shortlist-proposal="$emit('shortlist-proposal', $event)"
                                    @park-proposal="$emit('park-proposal', $event)"
                                    @add-comment="$emit('add-comment', $event)"
                                    @change-expenditure="$emit('change-expenditure', $event)"
                                    @view-attachments="$emit('view-attachments', $event)"
                                    @assign-fund-source="$emit('assign-fund-source', { ...$event, campus: $event && $event.campus ? $event.campus : campus, campusId: $event && $event.campusId ? $event.campusId : (campus ? campus.id : null) })" />
                            </b-collapse>
                        </div>
                    </b-collapse>
                </div>
            </template>
        </div>
    </div>
</template>